export const SESSION_POLICY_DEFAULT = "default";
export const SESSION_POLICY_CUSTOM = "custom";
export const SESSION_POLICY_UNLIMITED = "unlimited";

export const SESSION_POLICY_OPTIONS = [
  { value: SESSION_POLICY_DEFAULT, label: "Default" },
  { value: SESSION_POLICY_UNLIMITED, label: "Unlimited" },
  { value: SESSION_POLICY_CUSTOM, label: "Custom" }
];

const default_session_minutes = 30;

export function normalize_session_policy(value) {
  const policy = String(value || SESSION_POLICY_DEFAULT).toLowerCase();

  return [
    SESSION_POLICY_DEFAULT,
    SESSION_POLICY_CUSTOM,
    SESSION_POLICY_UNLIMITED
  ].includes(policy)
    ? policy
    : SESSION_POLICY_DEFAULT;
}

export function normalize_session_timeout_minutes(value) {
  const minutes = Number(value);
  return Number.isFinite(minutes) && minutes > 0 ? Math.round(minutes) : null;
}

export function get_profile_session_policy(profile = {}) {
  return normalize_session_policy(
    profile.session_policy
      || profile.sessionPolicy
      || profile.profile?.session_policy
      || profile.profile?.sessionPolicy
  );
}

export function get_profile_session_timeout_minutes(profile = {}) {
  return normalize_session_timeout_minutes(
    profile.session_timeout_minutes
      ?? profile.sessionTimeoutMinutes
      ?? profile.profile?.session_timeout_minutes
      ?? profile.profile?.sessionTimeoutMinutes
  );
}

export function get_session_form_defaults(profile = {}) {
  const session_policy = get_profile_session_policy(profile);
  const session_timeout_minutes = get_profile_session_timeout_minutes(profile);

  return {
    session_policy,
    session_timeout_minutes: session_policy === SESSION_POLICY_CUSTOM
      ? session_timeout_minutes || default_session_minutes
      : default_session_minutes
  };
}

export function build_session_profile_payload(form = {}) {
  const session_policy = normalize_session_policy(form.session_policy);
  const timeout_minutes = normalize_session_timeout_minutes(form.session_timeout_minutes);

  return {
    session_policy,
    session_timeout_minutes: session_policy === SESSION_POLICY_CUSTOM ? timeout_minutes : null
  };
}

export function validate_session_form(form = {}) {
  if (normalize_session_policy(form.session_policy) !== SESSION_POLICY_CUSTOM) {
    return "";
  }

  const timeout_minutes = normalize_session_timeout_minutes(form.session_timeout_minutes);

  if (!timeout_minutes) {
    return "Enter a custom session duration.";
  }

  if (timeout_minutes < 1) {
    return "Session duration must be at least 1 minute.";
  }

  return "";
}

export function get_session_policy_label(profile = {}) {
  const policy = get_profile_session_policy(profile);

  if (policy === SESSION_POLICY_UNLIMITED) {
    return "Unlimited";
  }

  if (policy === SESSION_POLICY_CUSTOM) {
    const timeout_minutes = get_profile_session_timeout_minutes(profile);
    return timeout_minutes ? `${timeout_minutes} min` : "Custom";
  }

  return "Default";
}
